// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description = "A simple module for showing sides of a debate.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Chat module",
  id: "chat-module",
  groupsWithAccess: ["admin_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable", "Chat"],
  description,
  image: DisplayImage,
  // cradleIframeUrlRoot:"http://localhost:3000/?resizable=true",
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/chat-module/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "ChatModuleConfigTool" */ "app/components/tools/ChatModuleConfigTool/ChatModuleConfigTool"),
    loading: DynamicImportLoader,
    modules: ["ChatModuleConfigTool"]
  })
};

export default CONFIG;
